export const resourceTypesCacheKeys = {
  all: ['resource-types-v5'] as const,
  list: () => [...resourceTypesCacheKeys.all, 'list'] as const,
  item: (id: number) => [...resourceTypesCacheKeys.all, 'item', id] as const
};
